import type { Meta } from '@/types/api';
import { Button } from './button';

export function Pagination({ meta, onPage, unit = 'row' }: { meta?: Meta; onPage: (page: number) => void; unit?: string }) {
  if (!meta) return null;

  const { current_page, total_pages, total_items } = meta;
  const label = `${total_items} ${unit}${total_items === 1 ? '' : 's'}`;

  if (total_pages <= 1) {
    return (
      <div className="flex items-center justify-between border-t border-rule px-3 py-2">
        <span className="font-mono text-tiny text-ink-3">{label}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between gap-3 border-t border-rule px-3 py-2">
      <span className="font-mono text-tiny text-ink-3">
        {label} · page {current_page} of {total_pages}
      </span>
      <div className="flex items-center gap-1.5">
        <Button size="sm" variant="secondary" disabled={current_page <= 1} onClick={() => onPage(current_page - 1)}>
          Previous
        </Button>
        <Button size="sm" variant="secondary" disabled={current_page >= total_pages} onClick={() => onPage(current_page + 1)}>
          Next
        </Button>
      </div>
    </div>
  );
}
